import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from '../hooks/useMetaPixel';
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = '🚀 GET BASKETBALL READY 360 NOW — ONLY $27',
  href = '#pricing',
  className = ''
}: CtaButtonProps) {
  const isExternal = href.startsWith('http');
  return <div className="relative w-full" data-id="element-76" data-mp="qkahx974n9vh">
      <span aria-hidden="true" className="cta-halo pointer-events-none absolute -inset-1 rounded-[1.4rem] bg-grass/45 blur-xl" data-id="element-77" data-mp="qj92ytmzq38h" />
      <a href={href} rel={isExternal ? 'noopener noreferrer' : undefined} onClick={() => trackPixelEvent('InitiateCheckout', {
      content_name: 'Basketball Ready 360 + Pro Tactical Kit',
      value: 27,
      currency: 'USD'
    })} className={`group relative flex w-full items-center justify-center overflow-hidden rounded-2xl bg-grass px-6 py-5 text-center text-lg font-extrabold text-white shadow-[0_10px_30px_-6px_rgba(0,200,83,0.65)] ring-1 ring-inset ring-white/25 transition-[transform,background-color,box-shadow] duration-150 ease-out hover:-translate-y-0.5 hover:bg-grass-dark hover:shadow-[0_16px_40px_-8px_rgba(0,200,83,0.85)] active:translate-y-0 focus:outline-none focus-visible:ring-4 focus-visible:ring-white/70 sm:text-xl ${className}`} data-id="element-78" data-mp="10adfznt3ve0o">
        <span aria-hidden="true" className="cta-shine pointer-events-none absolute inset-y-0 -left-1/3 w-1/3 bg-white/30 blur-md" data-id="element-79" data-mp="3ov8qc6z55b6m" />
        <span className="relative flex items-center justify-center gap-2.5" data-id="element-80" data-mp="1j7rkxcyp8cx">
          <span data-id="element-81" data-mp="1lae37ewojcw">{label}</span>
          <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-82" data-mp="6ikd9es3k9dx" />
        </span>
      </a>
    </div>;
}